import { LoginValues } from '@/pages/unauthenticated/Login';
import { getErrorCodes } from '@/utils/utilities';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import httpClient from './httpClient';

type TokenResponse = {
	accessToken: string;
	refreshToken: string;
};

abstract class UnauthenticatedApi {
	static async login({ email, password }: LoginValues) {
		const response = await httpClient.post<TokenResponse>(
			`${ApiQueryKey.auth}/login`,
			{
				email,
				password,
			}
		);

		return response;
	}

	static async refreshToken(refreshToken: string) {
		const response = await httpClient.post<TokenResponse>(
			`${ApiQueryKey.auth}/refresh`,
			{
				refreshToken,
			}
		);
		return response;
	}

	static async requestResetPassword(email: string) {
		try {
			await httpClient.post(
				`${ApiQueryKey.auth}/reset_password/create`,
				{
					email,
					redirectUrl: `${import.meta.env.VITE_APP_URL}set-password`,
				}
			);
			return 3;
		} catch (error) {
			const message = getErrorCodes(error);
			return { message };
		}
	}

	static async resetPassword(hash: string, password: string) {
		try {
			await httpClient.post(
				`${ApiQueryKey.auth}/reset_password/process`,
				{
					hash,
					password,
				}
			);
			return 3;
		} catch (error) {
			const message = getErrorCodes(error);

			return { message };
		}
	}

	static async adminHandoff() {
		const response = await httpClient.post<{ code: string }>(
			`${ApiQueryKey.auth}/admin-handoff`,
			{}
		);
		return response.data.code;
	}
}

export default UnauthenticatedApi;
